import AffiliatesProgram from '../../views/AffiliatesProgram/components/Overview'

export default AffiliatesProgram
